import { AnyAction } from 'redux';
import {
  UPDATESIDEBARTAB,
  UPDATE_BREADCRUMB,
  UPDATE_IS_LOADER,
  SIBEBAR_LAYOUT_CHANGE,
  UPDATE_TOKEN_INFO,
  UPDATE_RESPONSIVE_SIDEBAR,
  INITIALIZE_STORE,
  UPDATE_DOWNLOAD_ID,
  UPDATE_FLASHBAR,
  UPDATE_REVIEW_TAB,
  UPDATE_REVIEW_CATEGORY_COUNT,
  AUTO_LOGOUT,
} from '../action';

export interface StateProps {
  isLoading: boolean;
  autoLogout: boolean;
  defaultSideBarTab: string;
  resposiveSidebar: boolean;
  crumbs: [{ path: string; name: string }];
  sidebarLayout: boolean;
  responsiveSidebar: boolean;
  tokenInfo: {
    accessToken: string;
    expiresIn: number;
    userInfo: {
      id: string;
      firstName: string;
      lastName: string;
      userName: string;
      organizationId: string;
      role: number;
      profileImage: string;
    };
  };
  downloadProps: {
    isShow: boolean;
    downloadGuid: string;
  };
  flashbar: {
    isOpen: boolean;
    message: string;
    type: string;
  };
  reviewTab: {
    tabName: string;
    siteOrgIndexID: string;
    categoryID: string;
    keywordID: string;
  };
  reviewCategoryCount: number;
  
}

const initialState: StateProps = {
  isLoading: false,
  autoLogout:false,
  defaultSideBarTab: 'Dashboard',
  resposiveSidebar: false,
  crumbs: [{ path: '', name: '' }],
  sidebarLayout: true,
  responsiveSidebar: false,
  tokenInfo: {
    accessToken: 'No token',
    expiresIn: 0,
    userInfo: {
      id: '',
      firstName: '',
      lastName: '',
      userName: '',
      organizationId: '',
      role: 0,
      profileImage: '',
    },
  },
  downloadProps: {
    isShow: false,
    downloadGuid: '',
  },
  flashbar: {
    isOpen: false,
    message: '',
    type: '',
  },
  reviewTab: {
    tabName: 'category',
    siteOrgIndexID: '',
    categoryID: '',
    keywordID: '',
  },
  reviewCategoryCount: 0,
};
const Counter = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case UPDATE_IS_LOADER:
      return {
        ...state,
        isLoading: action.payload,
      };
    case UPDATE_BREADCRUMB:
      return {
        ...state,
        crumbs: action.payload,
      };
    case UPDATESIDEBARTAB:
      return {
        ...state,
        defaultSideBarTab: action.payload,
      };
    case SIBEBAR_LAYOUT_CHANGE:
      return {
        ...state,
        sidebarLayout: action.payload,
      };
    case UPDATE_RESPONSIVE_SIDEBAR:
      return {
        ...state,
        responsiveSidebar: action.payload,
      };
    case UPDATE_TOKEN_INFO:
      return {
        ...state,
        tokenInfo: action.payload,
      };
    case UPDATE_DOWNLOAD_ID:
      return {
        ...state,
        downloadProps: action.payload,
      };
    case UPDATE_FLASHBAR:
      return {
        ...state,
        flashbar: action.payload,
      };
    case UPDATE_REVIEW_TAB:
      return {
        ...state,
        reviewTab: action.payload,
      };
    case UPDATE_REVIEW_CATEGORY_COUNT:
      return {
        ...state,
        reviewCategoryCount: action.payload,
      };
    case INITIALIZE_STORE:
      return {
        ...initialState,
      };
      case AUTO_LOGOUT:
        return{
          ...state,
          autoLogout:action.payload,
        }
    default:
      return state;
  }
};
export default Counter;
